<template>
  <AppTooltip>
    <template #activator="{ props }">
      <app-button class="ml-1"
        type="icon"
        v-bind="props"
      >
        <app-material-icon name="attach_file" color="inherit" />
      </app-button>
    </template>
    <div>
      {{ $t('project.checklist.dialogs.SaveChecklistFromTemplateDialog.checklistPreview.attachments') }}
      <ul>
        <li v-for="(fileName, index) in task.attachments" :key="`attachment-${index}`">
          {{ fileName }}
        </li>
      </ul>
    </div>
  </AppTooltip>
</template>

<script>
  import AppTooltip from '@/common/AppTooltip.vue'

  export default {
    name: 'SavedChecklistPreviewAttachments',
    components: {
      AppTooltip,
    },
    props: {
      task: {
        type: Object,
        required: true,
      },
    },
  }
</script>
